import Ajax from '@lib/ajax'

export default {

  async create(payload){
    return Ajax.post('/api/services/app/Role/Create', payload);
  },
  async update(payload){
    return Ajax.put('/api/services/app/Role/Update', payload);
  },
  async delete(id){
    return Ajax.delete('/api/services/app/Role/Delete?Id='+ id);
  },
  async get(id){
    return Ajax.get('/api/services/app/Role/Get?Id='+ id);
  },
  async getAll(payload){
    return Ajax.get('/api/services/app/Role/GetAll',{params:payload.data});
  },
  async getAllRoles(){
    return Ajax.get('/api/services/app/Role/GetAllRoles');
  },
  async getRoles(){
    return Ajax.get('/api/services/app/Role/GetRoles');
  },
  async getRolesGridResult(payload){
    return Ajax.get('/api/services/app/Role/GetRolesGridResult', payload);
  },
  async getRolePermissionsFlatTree(id){
    if(id == null) {
      id = 0;
    }
    return Ajax.get('/api/services/app/Role/GetRolePermissionsFlatTree?Id=' + id);
  }
}